import { ref, Ref } from "vue";

export interface Message {
  closable?: boolean;
  detail?: string;
  life?: number;
  severity: "success" | "info" | "warn" | "error";
  summary?: string;
  title?: string;
}

const messenger = ref<Message | null>(null);

interface UseToast {
  messenger: Ref<Message | null>;
  toast: (message: Message) => void;
  toastWarning: (message: Omit<Message, "severity">) => void;
  toastSuccess: (message: Omit<Message, "severity">) => void;
  toastError: (message: Omit<Message, "severity">) => void;
  toastInfo: (message: Omit<Message, "severity">) => void;
}

export default function useToast(): UseToast {
  const toast = (message: Message) => {
    messenger.value = { ...message };
  };

  const toastError = (message: Omit<Message, "severity">) => {
    messenger.value = { ...message, severity: "error" };
  };

  const toastWarning = (message: Omit<Message, "severity">) => {
    messenger.value = { ...message, severity: "warn" };
  };

  const toastSuccess = (message: Omit<Message, "severity">) => {
    messenger.value = { ...message, severity: "success" };
  };

  const toastInfo = (message: Omit<Message, "severity">) => {
    messenger.value = { ...message, severity: "info" };
  };

  return {
    messenger,
    toast,
    toastWarning,
    toastSuccess,
    toastError,
    toastInfo,
  };
}
